import React from 'react';
import { observer } from 'mobx-react-lite';
import { useRootStore } from '../../App';
import { ChatMessage } from '../molecules/ChatMessage';
import { ChatLeft } from '../molecules/ChatLeft';
import styled from 'styled-components';
import ClearFixStyle from '../atoms/ClearFixStyle';

const BaseStyledDiv = styled.div`
  background: #fff;
  color: #333;
  font-size: 14px;
  line-height: 1.5;
  padding: ${(props: { isWide: boolean }) =>
    props.isWide ? '0 32px 11px' : '16px 16px 16px'};
  ${(props: { isWide: boolean }) =>
    props.isWide
      ? `word-wrap: break-word;`
      : `border-collapse: separate;
      border-radius: 16px;`}
`;

const RecipientStatusStyleDiv = styled.div`
  font-size: 12px;
  color: #828282;
  ${(props: { isWide: boolean }) =>
    props.isWide
      ? `float: left;
      padding-right: 2%;
      ${ClearFixStyle}`
      : `margin-top: 0px;
      text-align: left;
      vertical-align: middle;`}
`;

interface Props {
  showRecipientTypingIcon: boolean;
  iconImageUrl: string;
}

export const ChatMessages = observer((props: Props) => {
  const { showRecipientTypingIcon, iconImageUrl } = props;
  const root = useRootStore();
  const { messageDivRef } = root.inquiryPageStore;
  const { sortedMessages } = root.messageStore;
  const { isWide } = root.layoutStore;
  const { user } = root.userStore;

  const onClickAttachmentThumbnail = (fileId: string, fileName: string) => {
    root.previewModalStore.setCurrentAttachment(fileId, fileName, false);
    root.previewModalStore.show();
  };

  return (
    <div>
      {sortedMessages.map((message, index) => {
        return (
          <>
            <ChatMessage
              key={`chat-message-${index}`}
              isWide={isWide}
              image={iconImageUrl}
              userId={user.userId}
              message={message}
              onClickAttachmentThumbnail={onClickAttachmentThumbnail}
              childrenContainerDivRef={messageDivRef}
              messageDivRef={messageDivRef}
              showInquiryId={index === 0}
            />
            {index === 0 && (
              <div className={'waitingMessage'}>
                <ChatLeft isWide={isWide} image={iconImageUrl}>
                  <BaseStyledDiv isWide={isWide}>
                    お問い合わせいただきありがとうございます。
                    <br />
                    こちらは自動で返信しております。
                    <br />
                    内容を確認でき次第ご連絡いたしますので、お待ちいただけますと幸いです。
                  </BaseStyledDiv>
                </ChatLeft>
              </div>
            )}
          </>
        );
      })}

      {showRecipientTypingIcon && (
        <div className={'recipientState'}>
          <ChatLeft isWide={isWide} image={iconImageUrl}>
            <BaseStyledDiv isWide={isWide}>
              <RecipientStatusStyleDiv isWide={isWide}>
                {/*...入力中... animation*/}
                <span className="text-animation-up-down active">
                  <span>.</span>
                  <span>.</span>
                  <span>.</span>
                  <span>入</span>
                  <span>力</span>
                  <span>中</span>
                  <span>.</span>
                  <span>.</span>
                  <span>.</span>
                </span>
              </RecipientStatusStyleDiv>
            </BaseStyledDiv>
          </ChatLeft>
        </div>
      )}
    </div>
  );
});
